export default "__VITE_ASSET__D7hkB8Km__"